/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClassProvider } from '@angular/core';
import { AuthInterceptor } from '@common-services/util/requestinterceptors/auth.interceptor';
import { BaseUrlInterceptor } from '@common-services/util/requestinterceptors/baseurl.interceptor';
import { ErrorInterceptor } from '@common-services/util/requestinterceptors/error.interceptor';
import { HeaderInterceptor } from '@common-services/util/requestinterceptors/header.interceptor';

/** Http interceptor providers in outside-in order */
export const RequestInterceptorProviders: ClassProvider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HeaderInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: BaseUrlInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
  },
];
